Number.prototype.toRoundString = function (digits = 0) {
  const factor = 10 ** digits;
  const rounded = Math.round(this * factor) / factor;
  return rounded.toFixed(digits);
};
